import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="images--loading"
export default class extends Controller {
  static targets = ["container", "image", "showcase"];

  connect() {
    if (this.imageTarget.complete) {
      this.reveal();
    }
  }

  reveal() {
    this.showcaseTarget.classList.remove("bg-main-300", "animate-pulse");
    this.containerTarget.classList.remove("invisible");
  }
}
